<div class="error__page-container">
  <div class="error__message">
    <h2>{{ (customVariables$ | async)?.VISALAC_500errorpage_title }}</h2>
    <p>{{ (customVariables$ | async)?.VISALAC_500errorpage_subtitle }}</p>
    <a class="error__link" [href]="(customVariables$ | async)?.VISALAC_500errorpage_buttonURL">
      {{ (customVariables$ | async)?.VISALAC_500errorpage_buttonlabel }}
    </a>
  </div>
</div>
